import React from "react";
//import PropTypes from 'prop-types';

import "./style.css";

export function SelectList(props) {
    const { children, onClick } = props;
    return (
        <div className={"select-list"} onClick={onClick}>
            {children}
        </div>
    );
}

SelectList.propTypes = {};

SelectList.defaultProps = {};

export default SelectList;
